import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import { Skeleton } from 'primereact/skeleton'
import { motion, AnimatePresence } from 'framer-motion'
import Item from './Item'
import './style.scss'
import { ENDPOINT } from '../../../env'
import axios from 'axios'

const order = ['highlights', 'broadcast', 'interview', 'videos', 'photos', 'news', 'previews']
const categoryLabels = {
    broadcast: 'Трансляции', news: 'Новости', interview: 'Интервью', highlights: 'Обзоры',
    previews: 'Анонсы', photos: 'Фото', videos: 'Видео'
}

const processCategories = arr => {
    return arr.map(cat => ({
        ...cat,
        label: cat.label || categoryLabels[cat.id] || cat.id
    })).sort((a, b) => {
        const aIdx = order.indexOf(a.id)
        const bIdx = order.indexOf(b.id)
        return (aIdx === -1 ? 999 : aIdx) - (bIdx === -1 ? 999 : bIdx)
    })
}

const MediaBlockV2 = ({ scope, subjectId, stashed }) => {
    const [data, setData] = useState(null)
    const [catIdx, setCatIdx] = useState(0)
    const [circleLeft, setCircleLeft] = useState(8)
    const navRef = useRef(null)
    const activeCatRef = useRef(null)

    useEffect(() => {
        if (!stashed && subjectId) {
            axios.get(`${ENDPOINT}client/mediablock/${subjectId}?scope=${scope}`)
                .then(resp => setData(processCategories(resp.data)))
        }
    }, [subjectId, scope, stashed])

    const updatePosition = useCallback(() => {
        if (activeCatRef.current && navRef.current) {
            const navRect = navRef.current.getBoundingClientRect()
            const activeRect = activeCatRef.current.getBoundingClientRect()
            const pos = activeRect.left - navRect.left + (activeRect.width - 54) / 2
            setCircleLeft(pos)
        } else if (data) {
            setCircleLeft(catIdx * 70 + 8)
        }
    }, [catIdx, data])

    useEffect(() => {
        const rafId = requestAnimationFrame(() => {
            requestAnimationFrame(updatePosition)
        })
        window.addEventListener('resize', updatePosition)
        return () => {
            cancelAnimationFrame(rafId)
            window.removeEventListener('resize', updatePosition)
        }
    }, [updatePosition])

    const carouselSource = useMemo(() => data?.[catIdx]?.data?.filter(i => i.type !== 'album') || [], [data, catIdx])

    const handleCatClick = useCallback((i) => setCatIdx(i), [])

    return  <div className='mb2'>
                <div className='nav-circle' style={{left: `${circleLeft}px`}} />
                <div className='nav-spot' style={{left: `${circleLeft + 17}px`}} />
                <div className='mb-body'>
                    <AnimatePresence mode='popLayout'>
                        {carouselSource.length ? (
                            <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}}>
                                <Splide options={{
                                    pagination: true, focus: 'center', type: 'loop', arrows: false,
                                    interval: 4500, perMove: 1, updateOnMove: false, waitForTransition: true, clones: 1
                                }}>
                                    {carouselSource.map((item, i) => (
                                        <SplideSlide key={i}>
                                            <Item data={{...item, attachments: item.attachments?.filter(a => a.type !== 'album')}} />
                                        </SplideSlide>
                                    ))}
                                </Splide>
                            </motion.div>
                        ) : (
                            <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}}>
                                <Skeleton className='slide-skeleton' />
                                <Skeleton className='date-skeleton' height={13} width={100} />
                                <Skeleton className='title-skeleton' height={18} />
                                <Skeleton className='title-skeleton-bottom' height={18} width={180} />
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
                <div className='nav' ref={navRef}>
                    {data ? data.map((cat, i) => (
                        <div
                            key={cat.id || i}
                            ref={i === catIdx ? activeCatRef : null}
                            className={`nav-cat${i === catIdx ? ' active' : ''}`}
                            onClick={() => handleCatClick(i)}
                        >
                            <div className='nav-cat_icon'><img src={cat.data[0]?.landscapeCover} alt='' /></div>
                            <span className='alterfont'>{cat.label}</span>
                        </div>
                    )) : Array(5).fill(0).map((_, i) => <Skeleton key={i} shape='circle' size={46} />)}
                </div>
            </div>
}

export default React.memo(MediaBlockV2)
